
import { mapState, mapGetters, mapActions } from 'vuex';
import PendingReviews from './components/PendingReviews';
import WrittenReviews from './components/WrittenReviews';

export default {
  i18nComponentKey: 'ManagingReviews.ManagingReviews',
  name: 'ManagingReviews',
  components: {
    PendingReviews,
    WrittenReviews
  },
  data() {
    return {
      activeTab: this.$route.query.tab === 'written' ? 'written' : 'pending',
      isLoading: true,
      pendingReviewsCount: null,
      writtenReviewsCount: null
    };
  },
  computed: {
    ...mapState(['api']),
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('session', ['isLoggedIn'])
  },
  mounted() {
    if (!this.isLoggedIn) this.confirmForLogin();

    this.notifyTargetClick();

    this.isLoading = true;
    this.api
      .fetchManagingReviewsCount()
      .then(({ data }) => {
        this.pendingReviewsCount = data.pending_reviews_count;
        this.writtenReviewsCount = data.written_reviews_count;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    ...mapActions('widget', ['confirmForLogin']),
    onTabClick(tab) {
      this.activeTab = tab;
    },
    notifyTargetClick() {
      const { cohort_item_id, sms } = this.$route.query;
      if (!(cohort_item_id && sms === '1')) return;

      this.api.targetClick(cohort_item_id);
    }
  }
};
